"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.regexp.split");
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.array.find");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es7.object.values");
require("core-js/modules/web.dom.iterable");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BookingTimeConfig',
  props: {
    shopData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isInBatchSetting: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      activeScene: 'zt',
      config: {
        enabled: false,
        scenes: {
          zt: [],
          wm: []
        }
      },
      idCounter: 1
    };
  },
  created: function created() {
    this.initConfig();
    // 添加全局点击事件监听
    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeDestroy: function beforeDestroy() {
    // 移除全局点击事件监听
    document.removeEventListener('click', this.handleGlobalClick);
  },
  methods: {
    initConfig: function initConfig() {
      var _this = this;
      // 从 shopData 中解析已有的预约时间配置
      if (this.shopData && this.shopData.bookingTimeConfig) {
        try {
          var parsed = JSON.parse(this.shopData.bookingTimeConfig);
          this.config = {
            enabled: parsed.enabled !== undefined ? parsed.enabled : true,
            scenes: {
              zt: parsed.scenes && parsed.scenes.zt || [],
              wm: parsed.scenes && parsed.scenes.wm || []
            }
          };
          // 为所有已有数据添加编辑状态字段
          Object.values(this.config.scenes).forEach(function (ranges) {
            ranges.forEach(function (range) {
              _this.$set(range, 'editingName', false);
              _this.$set(range, 'editingTime', false);
              _this.$set(range, 'editingBookable', false);
              _this.$set(range, 'editingRemark', false);
            });
          });
          this.updateIdCounter();
        } catch (e) {
          console.error('解析预约时间配置失败:', e);
        }
      } else {
        // 没有配置时，仅在非批量设置页面默认启用分时段预订；批量设置不预填默认值
        if (!this.isInBatchSetting) {
          this.config.enabled = true;
        }
      }
    },
    handleSceneChange: function handleSceneChange() {
      // 切换场景时的处理
    },
    updateIdCounter: function updateIdCounter() {
      // 更新ID计数器
      var maxId = 0;
      Object.values(this.config.scenes).forEach(function (ranges) {
        ranges.forEach(function (range) {
          if (range.id && range.id > maxId) {
            maxId = range.id;
          }
        });
      });
      this.idCounter = maxId + 1;
    },
    addTimeRange: function addTimeRange() {
      var _this2 = this;
      var sceneRanges = this.config.scenes[this.activeScene] || [];

      // 获取智能默认时间
      var _this$getDefaultBooka = this.getDefaultBookableTime(sceneRanges),
        bookableStart = _this$getDefaultBooka.bookableStart,
        bookableEnd = _this$getDefaultBooka.bookableEnd;
      var newRange = {
        id: this.idCounter++,
        name: '',
        bookingStart: bookableStart,
        bookingEnd: bookableEnd,
        bookableStart: bookableStart,
        bookableEnd: bookableEnd,
        remark: '',
        editingName: false,
        editingTime: false,
        editingBookable: false,
        editingRemark: false
      };
      if (!this.config.scenes[this.activeScene]) {
        this.$set(this.config.scenes, this.activeScene, []);
      }
      this.config.scenes[this.activeScene].push(newRange);

      // 自动开启名称编辑状态
      this.$nextTick(function () {
        _this2.$set(newRange, 'editingName', true);
      });
    },
    getDefaultBookableTime: function getDefaultBookableTime(sceneRanges) {
      // 如果为空，使用当前时间作为开始时间，加1小时作为结束时间
      if (!sceneRanges || sceneRanges.length === 0) {
        var now = new Date();
        var currentHour = String(now.getHours()).padStart(2, '0');
        var currentMinute = String(now.getMinutes()).padStart(2, '0');
        var startTime = "".concat(currentHour, ":").concat(currentMinute);
        var endTime = this.addHours(startTime, 1);
        return {
          bookableStart: startTime,
          bookableEnd: endTime
        };
      }

      // 按开始时间排序
      var sortedRanges = (0, _toConsumableArray2.default)(sceneRanges).sort(function (a, b) {
        return (a.bookableStart || '').localeCompare(b.bookableStart || '');
      });

      // 找到最大的结束时间作为新的开始时间
      var lastRange = sortedRanges[sortedRanges.length - 1];
      var bookableStart = lastRange.bookableEnd || '08:00';

      // 默认可预约时间为1小时
      var bookableEnd = this.addHours(bookableStart, 1);
      return {
        bookableStart: bookableStart,
        bookableEnd: bookableEnd
      };
    },
    startEdit: function startEdit(row, field) {
      // 关闭其他行的编辑状态
      var currentScene = this.config.scenes[this.activeScene];
      currentScene.forEach(function (item) {
        if (item.id !== row.id) {
          item.editingName = false;
          item.editingTime = false;
          item.editingBookable = false;
          item.editingRemark = false;
        }
      });

      // 记录原始时间值，用于判断是否真正修改
      if (field === 'bookable' || field === 'time') {
        this.$set(row, '_originalTime', {
          bookableStart: row.bookableStart,
          bookableEnd: row.bookableEnd
        });
      }

      // 开启当前行的编辑状态
      if (field === 'name') {
        this.$set(row, 'editingName', true);
      } else if (field === 'time') {
        this.$set(row, 'editingTime', true);
      } else if (field === 'bookable') {
        this.$set(row, 'editingBookable', true);
      } else if (field === 'remark') {
        this.$set(row, 'editingRemark', true);
      }
    },
    handleTimeChange: function handleTimeChange(row) {
      // 时间改变时自动同步
      if (row.bookableStart) {
        row.bookingStart = row.bookableStart;
      }
      if (row.bookableEnd) {
        row.bookingEnd = row.bookableEnd;
      }
    },
    handleBlurSave: function handleBlurSave(row, field) {
      // 失焦时先同步时间
      if (field === 'time' || field === 'bookable') {
        if (row.bookableStart) row.bookingStart = row.bookableStart;
        if (row.bookableEnd) row.bookingEnd = row.bookableEnd;
      }

      // 关闭编辑状态
      if (field === 'name') {
        this.$set(row, 'editingName', false);
      } else if (field === 'remark') {
        this.$set(row, 'editingRemark', false);
      } else if (field === 'time') {
        this.$set(row, 'editingTime', false);
      } else if (field === 'bookable') {
        this.$set(row, 'editingBookable', false);
      }

      // 验证并保存
      var isValid = this.validateAndSave(row);

      // 如果验证失败，重新打开编辑状态
      if (!isValid) {
        if (field === 'name') this.$set(row, 'editingName', true);else if (field === 'remark') this.$set(row, 'editingRemark', true);else if (field === 'time') this.$set(row, 'editingTime', true);else if (field === 'bookable') this.$set(row, 'editingBookable', true);
      }
    },
    handleGlobalClick: function handleGlobalClick(event) {
      var _this3 = this;
      // 检查点击的是否是可编辑元素
      var isEditableElement = event.target.closest('.editable-text') || event.target.closest('.el-input') || event.target.closest('.el-time-picker');
      if (!isEditableElement) {
        // 点击的不是可编辑元素，先验证再关闭
        this.$nextTick(function () {
          var currentScene = _this3.config.scenes[_this3.activeScene];
          var hasEditingRow = currentScene.some(function (item) {
            return item.editingTime || item.editingBookable || item.editingName || item.editingRemark;
          });
          if (hasEditingRow) {
            // 找到正在编辑的行
            var editingRow = currentScene.find(function (item) {
              return item.editingTime || item.editingBookable || item.editingName || item.editingRemark;
            });
            if (editingRow) {
              // 验证，失败则不关闭
              var isValid = _this3.validateAndSave(editingRow);
              if (!isValid) {
                // 验证失败，保持编辑状态
                return;
              }
            }
          }

          // 验证通过或没有编辑中的行，关闭所有编辑状态
          _this3.closeAllEditing();
        });
      }
    },
    closeAllEditing: function closeAllEditing() {
      var currentScene = this.config.scenes[this.activeScene];
      currentScene.forEach(function (item) {
        item.editingName = false;
        item.editingTime = false;
        item.editingBookable = false;
        item.editingRemark = false;
      });
    },
    syncToOtherScenes: function syncToOtherScenes() {
      var _this4 = this;
      var sceneNames = {
        zt: '自提',
        wm: '外卖'
      };
      var currentSceneName = sceneNames[this.activeScene];
      var otherScenes = Object.keys(sceneNames).filter(function (key) {
        return key !== _this4.activeScene;
      });
      var otherSceneNames = otherScenes.map(function (key) {
        return sceneNames[key];
      }).join('、');
      this.$confirm("\u786E\u5B9A\u8981\u5C06\u300C".concat(currentSceneName, "\u300D\u7684\u914D\u7F6E\u540C\u6B65\u5230\u300C").concat(otherSceneNames, "\u300D\u5417\uFF1F\u6B64\u64CD\u4F5C\u5C06\u8986\u76D6\u76EE\u6807\u573A\u666F\u7684\u73B0\u6709\u914D\u7F6E\u3002"), '同步确认', {
        confirmButtonText: '确定同步',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 深拷贝当前场景的配置
        var currentConfig = JSON.parse(JSON.stringify(_this4.config.scenes[_this4.activeScene]));

        // 清除编辑状态
        currentConfig.forEach(function (item) {
          item.editingName = false;
          item.editingTime = false;
          item.editingBookable = false;
          item.editingRemark = false;
        });

        // 同步到其他场景
        otherScenes.forEach(function (scene) {
          _this4.$set(_this4.config.scenes, scene, currentConfig);
        });
        _this4.$message.success('同步成功');
      }).catch(function () {
        // 用户取消操作
      });
    },
    validateAndSave: function validateAndSave(row) {
      // 验证必填字段
      if (!row.bookingStart || !row.bookingEnd || !row.bookableStart || !row.bookableEnd) {
        return false;
      }

      // 验证时间逻辑
      var timeValid = this.validateTimeLogic(row);
      if (!timeValid) return false;

      // 判断是否真正修改了时间（对比原始值）
      var hasTimeChanged = row._originalTime && (row.bookableStart !== row._originalTime.bookableStart || row.bookableEnd !== row._originalTime.bookableEnd);

      // 只有真正修改了才执行自动调节
      if (hasTimeChanged) {
        this.autoAdjustTimeRanges(row);
      }

      // 清除原始值记录
      delete row._originalTime;

      // 验证通过后自动排序
      this.sortSceneRanges();
      return true;
    },
    validateTimeLogic: function validateTimeLogic(row) {
      // 验证时间逻辑
      if (row.bookingStart >= row.bookingEnd) {
        this.$message.warning('预约结束时间必须大于开始时间');
        return false;
      }
      if (row.bookableStart >= row.bookableEnd) {
        this.$message.warning('可预约结束时间必须大于开始时间');
        return false;
      }
      return true;
    },
    autoAdjustTimeRanges: function autoAdjustTimeRanges(currentRow) {
      var currentScene = this.config.scenes[this.activeScene];
      if (!currentScene || currentScene.length <= 1) return;
      var newStart = currentRow.bookableStart;
      var newEnd = currentRow.bookableEnd;

      // 遍历其他时间段，自动调整重叠部分
      for (var i = currentScene.length - 1; i >= 0; i--) {
        var item = currentScene[i];
        if (item.id === currentRow.id) continue;
        var itemStart = item.bookableStart;
        var itemEnd = item.bookableEnd;

        // 情况1：其他时间段完全被新时间段包含，删除该时间段
        if (itemStart >= newStart && itemEnd <= newEnd) {
          currentScene.splice(i, 1);
          continue;
        }

        // 情况2：新时间段完全包含在其他时间段内，拆分其他时间段
        if (itemStart < newStart && itemEnd > newEnd) {
          // 需要拆分成两个时间段
          var firstPart = _objectSpread(_objectSpread({}, item), {}, {
            id: this.idCounter++,
            bookableStart: itemStart,
            bookableEnd: newStart,
            bookingStart: itemStart,
            bookingEnd: newStart,
            editingName: false,
            editingTime: false,
            editingBookable: false,
            editingRemark: false
          });
          var secondPart = _objectSpread(_objectSpread({}, item), {}, {
            id: this.idCounter++,
            bookableStart: newEnd,
            bookableEnd: itemEnd,
            bookingStart: newEnd,
            bookingEnd: itemEnd,
            editingName: false,
            editingTime: false,
            editingBookable: false,
            editingRemark: false
          });

          // 删除原时间段，添加拆分后的两个时间段
          currentScene.splice(i, 1, firstPart, secondPart);
          continue;
        }

        // 情况3：其他时间段开始时间在新时间段内，调整开始时间
        if (itemStart >= newStart && itemStart < newEnd && itemEnd > newEnd) {
          item.bookableStart = newEnd;
          item.bookingStart = newEnd;
          continue;
        }

        // 情况4：其他时间段结束时间在新时间段内，调整结束时间
        if (itemStart < newStart && itemEnd > newStart && itemEnd <= newEnd) {
          item.bookableEnd = newStart;
          item.bookingEnd = newStart;
          continue;
        }
      }
    },
    deleteRow: function deleteRow(index) {
      var _this5 = this;
      this.$confirm('确定删除该时间段吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.config.scenes[_this5.activeScene].splice(index, 1);
      });
    },
    handleSubmit: function handleSubmit() {
      // 提交配置
      this.$emit('submit', {
        storeId: this.shopData.storeId,
        bookingTimeConfig: JSON.stringify(this.config)
      });
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    },
    // 添加小时到时间字符串
    addHours: function addHours(timeStr, hours) {
      if (!timeStr) return '';
      var _timeStr$split$map = timeStr.split(':').map(Number),
        _timeStr$split$map2 = (0, _slicedToArray2.default)(_timeStr$split$map, 2),
        h = _timeStr$split$map2[0],
        m = _timeStr$split$map2[1];
      var newH = h + hours;
      return "".concat(String(newH).padStart(2, '0'), ":").concat(String(m).padStart(2, '0'));
    },
    // 对当前场景的时间段按可预约开始时间排序
    sortSceneRanges: function sortSceneRanges() {
      var sceneRanges = this.config.scenes[this.activeScene];
      if (!sceneRanges || sceneRanges.length <= 1) return;

      // 按bookableStart排序
      sceneRanges.sort(function (a, b) {
        return (a.bookableStart || '').localeCompare(b.bookableStart || '');
      });

      // 触发Vue响应式更新
      this.$set(this.config.scenes, this.activeScene, (0, _toConsumableArray2.default)(sceneRanges));
    }
  },
  computed: {
    currentSceneRanges: function currentSceneRanges() {
      return this.config.scenes[this.activeScene] || [];
    }
  }
};